import { SURVEY_STATES } from '../../constants/surveyConstants';

/**
 * The badge classes for a survey state, for every surface that shows one.
 *
 * One map, because the list and the detail view had drifted: draft was yellow on one and grey on
 * the other. Membership is what the guard asserts — `archived`'s neutral grey is deliberate.
 */
const BADGE_CLASSES: Record<string, string> = {
  [SURVEY_STATES.DRAFT]: 'bg-yellow-100 text-yellow-800',
  [SURVEY_STATES.ACTIVE]: 'bg-green-100 text-green-800',
  [SURVEY_STATES.COMPLETED]: 'bg-blue-100 text-blue-800',
  [SURVEY_STATES.ARCHIVED]: 'bg-gray-100 text-gray-800',
};

/** Unknown states fall back to neutral rather than rendering unstyled. */
export const UNKNOWN_STATE_BADGE_CLASS = 'bg-gray-100 text-gray-800';

export const surveyStateBadgeClass = (state: string): string =>
  BADGE_CLASSES[state] ?? UNKNOWN_STATE_BADGE_CLASS;

/**
 * Whether a state is mapped at all. Needed because `archived`'s deliberate neutral happens to equal
 * the unknown fallback, so comparing classes cannot tell "mapped and gray" from "not mapped" — and a
 * test that compared them would push the product into repainting archived just to stay distinguishable.
 */
export const hasSurveyStateBadge = (state: string): boolean => state in BADGE_CLASSES;
